import betsGeneral from '@/store/modules/bets/general';

export default {
  betsGeneral,
};
